import "./ExperienceDetail.scss";

const Codeweavers = () => {
  return (
    <div className="experience-detail">
      <div className="experience-detail__container">
        <div className="experience-detail__header">
          <span className="experience-detail__tenure">
            August 2023 - February 2024
          </span>
          <h1 className="experience-detail__title">
            Front End Engineer at Codeweavers
          </h1>
        </div>

        <div className="experience-detail__content">
          <section className="experience-detail__section">
            <h2>Overview</h2>
            <p>
              Worked as a Front End Engineer on the Angular Apps that powered
              the Codeweavers Platform, picked up tickets from various clients
              to add new functionality as well as fix bugs and run deployments
              multiple times a day.
            </p>
          </section>

          <section className="experience-detail__section">
            <h2>Responsibilities</h2>
            <ul>
              <li>
                Developing and maintaining Angular applications for the
                Codeweavers Platform
              </li>
              <li>Implementing new features based on client requirements</li>
              <li>
                Bug fixing and troubleshooting across multiple client projects
              </li>
              <li>Managing multiple daily deployments to production</li>
              <li>
                Working with cross-functional teams to deliver client solutions
              </li>
            </ul>
          </section>

          <section className="experience-detail__section">
            <h2>Tech Stack</h2>
            <div className="experience-detail__tags">
              <span className="experience-detail__tag">Angular</span>
              <span className="experience-detail__tag">TypeScript</span>
              <span className="experience-detail__tag">SCSS</span>
              <span className="experience-detail__tag">RxJS</span>
            </div>
          </section>
        </div>

        <a href="/" className="experience-detail__back-link">
          ← Back to Portfolio
        </a>
      </div>
    </div>
  );
};

export default Codeweavers;
